import { yup } from "@swa-ui/object";

export const ACCESSIBILITY_ACCOMMODATIONS_SCHEMA_FIELD_NAMES = {
  COGNITIVE_DISABILITY: "passengerDisabilityCognitive",
  HEARING_DISABILITY: "passengerDisabilityDeaf",
  VISION_DISABILITY: "passengerDisabilityBlind",
};

export const getAccessibilityAccommodationsFormFieldsSchema = (fieldNames = {}) => {
  const { COGNITIVE_DISABILITY, HEARING_DISABILITY, VISION_DISABILITY } =
    ACCESSIBILITY_ACCOMMODATIONS_SCHEMA_FIELD_NAMES;
  const {
    congnitiveDisability = COGNITIVE_DISABILITY,
    hearingDisability = HEARING_DISABILITY,
    visionDisability = VISION_DISABILITY,
  } = fieldNames;

  return {
    [congnitiveDisability]: yup.boolean(),
    [hearingDisability]: yup.boolean(),
    [visionDisability]: yup.boolean(),
  };
};
